import SigliveServiceV2 from 'Service/sigliveServiceV2';

const getHostSchedule = async (queries = '') => {
  const { data } = await SigliveServiceV2({ method: 'GET', url: `/productivity-host/schedule/list?${queries}` });

  return data?.data;
};

export default getHostSchedule;
